import { motion } from "framer-motion";
import { skipIntro } from "../lib/introAnimation";

const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.14 }) {
    return (
        <span className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        initial={skipIntro() ? false : { y: "115%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 1, delay: delay + i * stagger, ease: EASE }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}

export function FadeUp({ children, delay = 0, y = 36, className = "", once = true, as = "div" }) {
    const Tag = motion[as];
    return (
        <Tag
            className={className}
            initial={skipIntro() ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-60px" }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </Tag>
    );
}

export function SectionLabel({ children, dark = false }) {
    return (
        <p
            className={`text-xs font-bold uppercase tracking-[0.25em] ${
                dark ? "text-gold" : "text-emergency"
            }`}
        >
            {children}
        </p>
    );
}
